var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import * as React from 'react';
/**
 * jsx options 定义的配置选项整理成标准格式
 * @param nodes
 */
export function convertChildrenToData(nodes) {
    return toArray(nodes)
        .map(function (node) {
        if (!React.isValidElement(node))
            return null;
        var _a = node, key = _a.key, _b = _a.props, children = _b.children, value = _b.value, restProps = __rest(_b, ["children", "value"]);
        return __assign({ key: key !== undefined ? key : value, value: value !== undefined ? value : '', children: children }, restProps);
    })
        .filter(function (data) { return data; });
}
/**
 * 使用 jsx options 定义配置选项，将其整理成数组
 * @param children
 */
export function toArray(children) {
    var ret = [];
    React.Children.forEach(children, function (child) {
        if (child === undefined || child === null)
            return;
        if (Array.isArray(child)) {
            ret = ret.concat(toArray(child));
        }
        else {
            ret.push(child);
        }
    });
    return ret;
}
/**
 * filter options
 */
export function filterOptions(searchValue, options, filterOption) {
    var filteredOptions = [];
    var filterFun;
    if (filterOption === false) {
        return __spread(options);
    }
    if (typeof filterOption === 'function') {
        filterFun = filterOption;
    }
    else {
        filterFun = function () { return true; };
    }
    options.forEach(function (item) {
        var matchOptions = filterFun(searchValue, item);
        if (matchOptions) {
            filteredOptions.push(item);
        }
    });
    return filteredOptions;
}
